module.exports = __webpack_public_path__ + "static/media/warning-block.f24b1ba0.svg";